<div
    class="sw-cms-el-moorl-product-buy-list"
    v-if="element.config.enableAddToCartAll"
>
    <ul
        v-if="element.data.products"
        class="moorl-product-buy-list-items"
    >
        <li v-for="product in element.data.products">
            <div
                class="moorl-product-buy-list-item"
                :class="itemClass"
            >
                <div
                    v-if="element.config.enableAddToCartAll.value"
                    class="form-check"
                >
                    <input
                        type="checkbox"
                        checked
                    />
                </div>
                <div class="product-cover">
                    <img
                        v-if="product.cover && product.cover.media"
                        :src="product.cover.media.url"
                        :alt="product.name"
                    />
                </div>
                <div class="product-content">
                    <div class="product-title">
                        {{ product.translated.name }}
                    </div>
                    <div v-if="product.parentId">
                        VARIANTS
                    </div>
                    <div
                        v-if="element.config.enablePrices.value"
                        class="products-buy-form-list-item-info-price"
                    >
                        {{ product.price[0].gross | numberFormat }}
                    </div>
                </div>
                <div
                    v-if="element.config.enableAddToCartSingle.value"
                    class="product-buy-form"
                >
                    <a
                        class="btn mt-button"
                        href="#"
                    >
                        <mt-icon name="regular-plus-s"/>
                    </a>
                </div>
            </div>
        </li>
    </ul>
    <mt-banner
        v-else
        variant="info"
    >
        {{ element.config.emptyText.value }}
    </mt-banner>
    <div
        v-if="element.config.enableAddToCartAll.value"
        class="moorl-product-buy-list-form"
    >
        <div class="mb-2">
            <div class="text-start">
                Selected items
                <span class="selected-items">{{ selectedItems }}</span>
            </div>
            <div class="text-end">
                Total:
                <span class="total-price">
                    {{ priceTotal | numberFormat }}
                </span>
            </div>
        </div>
        <a
            class="btn mt-button mt-button--primary"
            href="#"
        >
            Add to Cart
        </a>
    </div>
</div>